import type { TFunction } from "i18next";

import { ApiError } from "@/api/client";

/** Translate any thrown value into a user-facing message. */
export function errorMessage(t: TFunction, error: unknown): string {
  const code = error instanceof ApiError ? error.code : "unknown";
  return t(`errors.${code}`, { defaultValue: t("errors.unknown") });
}

/** Map API field errors (``{"new_password": "too_short"}``) onto a form's field names. */
export function fieldErrors(error: unknown): Record<string, string> {
  return error instanceof ApiError ? error.fields : {};
}
